<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-alert variant="warning"
                   dismissible
                   :show="browserMsg.length > 0"
                   @dismissed="showDismissibleAlert=false">
            {{ browserMsg }}
          </b-alert>
          <b-card-group>
            <b-card no-body class="p-4" v-on:keyup.enter="login">
              <b-card-body>
                <h1>Login</h1>
                <b-alert :variant="dismissibleType"
                         dismissible
                         :show="showDismissibleAlert"
                         @dismissed="showDismissibleAlert=false">
                  {{ errMsg }}
                </b-alert>
                <p class="text-muted">Sign In to your account</p>

                <b-input-group class="mb-3">
                  <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                  <input v-model.trim="loginInfo.login" type="text" class="form-control" placeholder="Username">
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                  <input v-model.trim="loginInfo.password" type="password" class="form-control" placeholder="Password">
                </b-input-group>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" @click="login" class="px-4">Login</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import Router from '@/router'
import Store from '@/store'
import VueCookies from 'vue-cookies'
import tokenexpiration from '@/shared/tokenexpiration'
import { load, getInstance } from 'recaptcha-v3'

Vue.use(VueCookies)

export default {
  name: 'login',
  components: {
    loading
  },
  async created () {
    if (tokenexpiration.checkCookieExpiredInLogin(this)) {
      this.errMsg = 'Sorry, your session has timed out because of inactivity. Please sign in again.'
      this.showDismissibleAlert = true
      this.dismissibleType = 'warning'
    }

    let ua = window.navigator.userAgent
    // IE 11
    let trident = ua.indexOf('Trident/')
    if (trident > 0) {
      let rv = ua.indexOf('rv:')
      if (rv > 0) {
        // var ie11 = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
        this.browserMsg = 'You may have a better experience with another browser like Chrome or Firefox.'
      }
    }
    await this.getReCaptchaValues()
  },
  data () {
    return {
      browserMsg: '',
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      reCaptchaSiteKey: '',
      recaptcha: undefined,
      tokenData: undefined,
      loginInfo: {
        login: '',
        password: ''
      }
    }
  },
  beforeCreate () {
    if (this.$cookies.isKey('.jwt')) {
      Router.push('/')
    }
  },
  methods: {
    async login () {
      let self = this
      this.boolLoading = true
      const token = (await self.recaptcha).execute('login')
      await token.then(result => {
        this.tokenData = result
      })
      let obj = {
        'loginInfo': this.loginInfo,
        'token': this.tokenData
      }
      await axios.post('/auth/authorize', obj)
        .then(response => {
          this.boolLoading = false

          localStorage.setItem('login', this.loginInfo.login)
          Store.commit('LOGIN_USER')
          Store.commit('PASSWORD_CHANGE_REQUIRED', response.data.password_change_requested)
          Store.commit('ROLE_SETUP', response.data.scope)

          if (response.data.password_change_requested) {
            Router.push('/MyProfile/1')
          } else {
            Router.push('/')
          }
        })
        .catch(error => {
          this.boolLoading = false
          this.errMsg = 'Invalid Login'
          if (error.response.data.error_description) {
            this.errMsg += ': ' + error.response.data.error_description;
            this.showDismissibleAlert = true;
          }
          this.showDismissibleAlert = true
          if (error.response.status === 504) { this.errMsg = 'Could not connect to server.' }
        })
    },
    async getReCaptchaValues () {
      try {
        let response = await axios.get('/auth/getrecaptchavalues')
        this.reCaptchaSiteKey = response.data.recaptchasitekey
        this.recaptcha = load(this.reCaptchaSiteKey, { autoHideBadge: true })
      } catch (error) {
        console.log(error)
        this.errMsg = 'Error getting ReCaptcha data.'
        this.showDismissibleAlert = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/auth/Login.vue